import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Draggable from 'components/flink-components/Draggable/Draggable';
import WhiteBox from 'components/flink-play/WhiteBox/WhiteBox';

import classes from './MathRodsGameModal.module.scss';

const GameModal = ({
  title,
  children,
  buttons,
  centerButtons,
  draggable = false,
  compact = false,
  containInViewport = false,
  mobile = false,
  buttonsColumn = false,
  draggableProps = {},
  innerClassnames = [],
  outerClassnames = [],
  contentClassnames = [],
}) => {
  const content = (
    <WhiteBox
      outerClass={classnames(classes.modal, ...outerClassnames, {
        [classes.fixedPosition]: !draggable,
        [classes.compact]: compact,
        [classes.contained]: containInViewport,
        [classes.mobile]: mobile,
      })}
      innerClass={classnames(classes['modal-inner'], ...innerClassnames)}
    >
      <div className={classes['title']}>{title}</div>
      {children && <div className={classnames(classes['content'], ...contentClassnames)}>{children}</div>}
      <div
        className={classnames(classes.buttons, {
          [classes.column]: buttonsColumn,
        })}
        style={centerButtons ? { justifyContent: 'center' } : {}}
      >
        {buttons.map(
          (btn, idx) =>
            !btn.dontShow && (
              <button
                key={idx}
                aria-label={btn.ariaLabel || btn.title}
                disabled={btn.disabled}
                onClick={btn.clickHandler}
              >
                {btn.icon && <img src={btn.icon} alt="" />}
                {btn.title}
              </button>
            )
        )}
      </div>
    </WhiteBox>
  );

  if (draggable) {
    return (
      <Draggable withOverlay {...draggableProps}>
        {content}
      </Draggable>
    );
  }

  return (
    <>
      <div className={classnames(classes.overlay, {[classes.mobileOverlay]:mobile})}></div>
      {content}
    </>
  );
};

GameModal.propTypes = {
  title: PropTypes.string,
  compact: PropTypes.bool,
  containInViewport: PropTypes.bool,
  mobile: PropTypes.bool,
  buttons: PropTypes.array.isRequired,
  innerClassnames: PropTypes.array,
  outerClassnames: PropTypes.array,
  contentClassnames: PropTypes.array,
};

export default GameModal;
